import { useContext, useEffect, useState } from 'react';
import { useSearchState } from 'src/pages/consumer/components/DishFirstHeader/store';
import { SearchDataContext } from 'src/pages/consumer/components/search/store/SearchDataContext';
import { useGetSearchData } from '../components/search/store/hooks/useGetSearch';
import { usePageSizeState } from '../components/search/store/hooks/usePageSize';
import { useSearchQueryState } from '../components/search/store/hooks/useSearchQuery';

export const useSearchResults = () => {
  const {
    data,
    loading,
    handleQueryChange,
    handleShowMoreDishes,
    isMoreResultsLoading,
    hasMoreResults,
    refreshSearch,
    activeZipCode,
  } = useContext(SearchDataContext);
  const query = useSearchQueryState();
  const { dishPageSize, shefPageSize } = usePageSizeState();
  const isShowing = useSearchState();
  const [cachedSearch, setCachedSearch] = useState(data);
  const [cachedQuery, setCachedQuery] = useState(query);

  const dataToUse = isShowing ? cachedSearch || data : data;
  const queryToUse = isShowing ? cachedQuery || query : query;

  const { shefResults = [], dishResults = [], cuisineResults = [] } = useGetSearchData(dataToUse);

  useEffect(() => {
    const shouldUpdateIfHidden = !isShowing && data && query && query !== cachedQuery;
    const shouldUpdateIfShowing = isShowing && data && !cachedSearch;
    if (shouldUpdateIfHidden || shouldUpdateIfShowing) {
      setCachedSearch(data);
      setCachedQuery(query);
    }
  }, [cachedQuery, cachedSearch, data, isShowing, query]);

  return {
    activeZipCode,
    cuisineResults,
    data: dataToUse,
    loading,
    dishPageSize,
    dishResults,
    handleQueryChange,
    handleShowMoreDishes,
    hasMoreResults,
    isMoreResultsLoading,
    isSearchShowing: isShowing,
    cachedQuery,
    query: queryToUse,
    refreshSearch,
    shefPageSize,
    shefResults,
  };
};
